import React from 'react';
import classnames from 'classnames';
import styles from './loader.module.css';

interface LoaderProps {
  isLoading?: boolean;
  className?: string;
}

export const Loader: React.FC<LoaderProps> = ({ isLoading, className }) => (
  <div
    className={classnames(styles.loader, className, {
      [styles.loaderVisible]: isLoading,
    })}
  />
);
